import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconSprite';

export const Controls = styled.div`
  ${tw`flex justify-center items-center lg:justify-end`}
`;

export const ControlItem = styled.button<{
  isActive: boolean;
}>`
  ${tw`cursor-pointer`}
  ${tw`rounded-full`}
  ${tw`w-[11px] h-[11px]`}
  ${tw`mx-[5px]`}
  ${tw`bg-ui-colours-ui3 lg:hover:bg-neutrals-n6`}
  ${({ isActive }) => isActive && tw`bg-secondary-s1`}
`;

export const ControlIcon = styled(Icon, {
  shouldForwardProp: (propName) => propName !== 'isDisabled',
})<{ isDisabled: boolean }>`
  ${tw`w-32 h-4`}
  ${tw`text-secondary-s1`}
  ${({ isDisabled }) => isDisabled && tw`text-ui-colours-ui3`}
`;
